<template>
  <section class="publication-single">
    <ResourcesMonitoringSingleHeader :publication="publication" />
    <ResourcesMonitoringSingleContent v-if="publication && publication.content" :publication="publication" />
    <ResourcesMonitoringSingleMore v-if="publication" :publication="publication" />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'ResourcesMonitoringSingle',
  components: { ...partials },
  props: {
    monitoringSlug: String
  },
  computed: {
    publication() {
      if (!this.$wp.secondaryDataLoaded) return null
      return this.$wp.allPublications[this.monitoringSlug] || null
    }
  },
  mounted() {
    this.$watch(
      '$wp.secondaryDataLoaded',
      isLoaded => {
        if (isLoaded) {
          console.log('Monitoring loaded:', this.$wp.allPublications, this.monitoringSlug)
        }
      },
      { immediate: true }
    )
  }
}
</script>
